import Layout from '@/views/layout/Layout'

const cmsAlbumRoute = {
  path: '/cms/album',
  component: Layout,
  redirect: '/cms/album/list',
  name: 'cms.album',
  meta: { title: '资讯', icon: 'cms' },
  children: [
    {
      path: 'list',
      name: 'cms.album.list',
      component: () => import('@/views/cms/album/list'),
      meta: { title: '相册列表', icon: 'ums-admin' }
    },
    {
      path: ':id/images',
      name: 'cms.album.image',
      hidden: true,
      props: true,
      component: () => import('@/views/cms/album/image'),
      meta: { title: '图片列表', icon: 'ums-admin' }
    },
    // {
    //   path: 'edit/:id',
    //   name: 'cms.album.edit',
    //   hidden: true,
    //   component: () => import('@/views/cms/album/edit'),
    //   meta: { title: '编辑资讯', icon: 'ums-admin' }
    // },
  ]
}

export default cmsAlbumRoute



// WEBPACK FOOTER //
// ./src/router/module/cmsAlbumRoute.js